import { render, staticRenderFns } from "./MailForget.vue?vue&type=template&id=31a41257&scoped=true&"
import script from "./MailForget.vue?vue&type=script&lang=js&"
export * from "./MailForget.vue?vue&type=script&lang=js&"
import style0 from "./MailForget.vue?vue&type=style&index=0&id=31a41257&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a41257",
  null
  
)

export default component.exports